import api from './api';
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';
import { notification, OptionProps } from '@digital/ui';
import { getAllAreas } from './area';
import { getAllDiretorias } from './diretoria';
import area from './mock/area';
import { getAllDepartamento } from './departamento';
import { downloadAnexo, downloadAnexoPost } from './apiAnexo';


export interface OrdemDeCompraResult {
  index: number,
  oc: number, /* - Número da Ordem de compra */
  emissao: string,  /* Data de emissão da OC */
  rc: number, /* Número da Requisição de Compra*/
  dir: string /*- Diretoria da demanda*/
  area: string /* - Área da Demanda*/
  depto: string /*- Departamento da Demanda*/
  tipo: string /*- Nova Contratação / Aditivo*/
  tipoServico: string/*- Descrito na Demanda*/
  requisitante: string /*- Nome do requisitante da demanda*/
  valorOc: string/*- Valor da Ordem de Compra*/
  tipoAlocacao: string /*- OPEX/CAPEX*/
  alocacao: string /*- Código OI/CC/OM*/
  ptr: string/*- Sim/Não*/
  emergencial: string/*- Sim/Não*/
  direcionada: string/*- Sim/Não*/
  comprador: string /*- Nome do comprador*/
  ddi: string/*- Sim/Não*/
  status: string/*- Status atual da Ordem de Compra*/
  visitaTecnica: string;
  elegibilidadeGovernanca : string;
}

export interface OrdemDeCompraFilter {
  dataInicio: Date,
  diretoriaIds: string[],
  areasIds: string[],
  departamentosIds: string[],
  statusIds: string[],
}


export const findAll = (filtros: OrdemDeCompraFilter) => {
  return api.post<OrdemDeCompraResult[]>(`relatorioOrdemDeCompra/findAll`, filtros, { disableNotification: 'true', });
}

export const exportToExcel = async (filtros: OrdemDeCompraFilter) => {
  const url = '/api/relatorioOrdemDeCompra/exportToExcel';
  await downloadAnexoPost('Relatório de Ordem de Compra.xlsx', url, filtros);
}


export const getAllRequisitanteOptions = () => api.get<OptionProps>(`relatorioOrdemDeCompra/getAllOptionPropsUsuarioRequisitante`);

export const getAllDiretorioOptions = () => {
  return getAllDiretorias().then(diretoria => (diretoria || []).map(a => ({ text: a.nome, value: a.id && a.id.toString() })));
}

export const getAllAreaOptions = () => {
  return getAllAreas().then(area => (area || []).map(a => ({ text: a.nome, value: a.id && a.id.toString() })));
}

export const getAllDepartamentoOptions = () => {
  return getAllDepartamento().then(departamento => (departamento || []).map(a => ({ text: a.nome, value: a.id && a.id.toString() })));
}

export const getAllStatusOptions = () => api.get<OptionProps>(`relatorioOrdemDeCompra/getAllOptionPropsStatusOrdemDecompra`);